import { render, staticRenderFns } from "./OnboardingMainTemplate.vue?vue&type=template&id=5ab15bfe"
import script from "./OnboardingMainTemplate.vue?vue&type=script&lang=js"
export * from "./OnboardingMainTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports